<template>
    <div>
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">企業・団体情報登録</h4>
                <form @submit.prevent="post_form">
                    <div class="row mt-3">
                        <div class="col col-4">
                            <label for="name">会社名</label><span class="badge rounded-pill bg-danger ms-2">必須</span>
                            <input type="text" class="form-control" aria-label="名称" v-model="name" required maxlength="100" />
                        </div>
                        <div class="col col-4">
                            <label for="Representatives_name">代表者名</label><span class="badge rounded-pill bg-danger ms-2">必須</span>
                            <input type="text" class="form-control" aria-label="代表者名" v-model="representatives_name" required maxlength="100" />
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col col-2">
                            <label for="zip">郵便番号</label><span class="badge rounded-pill bg-danger ms-2">必須</span>
                            <input type="text" class="form-control" aria-label="郵便番号" v-model="zip" required maxlength="7" @blur="onZipChange($event)" />
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col col-2">
                            <label for="prefecture">都道府県</label><span class="badge rounded-pill bg-danger ms-2">必須</span>
                            <input type="text" class="form-control" aria-label="都道府県" v-model="prefecture" maxlength="10" />
                        </div>
                        <div class="col col-2">
                            <label for="city">市区町村</label><span class="badge rounded-pill bg-danger ms-2">必須</span>
                            <input type="text" class="form-control" aria-label="市区町村" v-model="city" maxlength="50" />
                        </div>
                        <div class="col col-4">
                            <label for="town">町名番地</label><span class="badge rounded-pill bg-danger ms-2">必須</span>
                            <input type="text" class="form-control" aria-label="町名番地" v-model="town" maxlength="255" />
                        </div>
                        <div class="col col-4">
                            <label for="building">建物名</label>
                            <input type="text" class="form-control" aria-label="建物名" v-model="building" maxlength="255" />
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col col-4">
                            <label for="tel">TEL</label>
                            <input type="text" class="form-control" aria-label="TEL" v-model="tel" maxlength="20" />
                        </div>
                        <div class="col col-4">
                            <label for="fax">FAX</label>
                            <input type="text" class="form-control" aria-label="FAX" v-model="fax" maxlength="20" />
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-1">
                            <button type="submit" class="btn btn-primary">登録</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <notifications position="top left" width="500px" />
</template>

<script>
import {defineComponent, reactive} from 'vue'
import { notify } from "@kyvg/vue3-notification";
notify({
  title: "Vue 3 notification 🎉",
});
import axios from 'axios';


export default defineComponent({
    setup(){

    },
    data() {
        return {
            name: "",
            representatives_name:"",
            zip: "",
            prefecture: "",
            city: "",
            town: "",
            building: "",
            tel: "",
            fax: "",
        }
    },
    methods: {
        onZipChange(e) {
            let self = this;
            const url = "/api/getAddressSeparate?zip=" + e.target.value;
            axios.get(url).then(function(response){
                if(response.status === 200) {
                    self.prefecture = response.data.prefecture;
                    self.city = response.data.municipalitie;
                    self.town = response.data.town;
                }
            });
            self.zip = e.target.value;
        },
        post_form(){
            const url = "/api/insertCorpInfo";
            axios.post(url,{
                "name": this.name,
                "zip": this.zip,
                "pref": this.prefecture,
                "city": this.city,
                "town": this.town,
                "building": this.building,
                "representative": this.representatives_name,
                "tel": this.tel,
                "fax": this.fax,
            }).then(res => {
                this.$notify({ type: "success", text: this.name + "を登録しました。" });
                this.name = "";
                this.zip = "";
                this.prefecture = "";
                this.city = "";
                this.town = "";
                this.building = "";
                this.representatives_name = "";
                this.tel = "";
                this.fax = "";
            });
        }

    }
})
</script>